import type { ChartRowProps, DonutChartDataProps } from "../components";

// Ámbito del resumen del Inicio: operaciones de los canales del usuario (ranking
// por producto), de sus productos como marca (ranking por retailer) o ambas.
export type DashboardScope = "channel" | "brand" | "all";

// Respuesta de GET /dashboard: agregada en el back sobre todo el periodo.
export interface DashboardSummaryProps {
  totals: { sales: number; redemptions: number };
  daily: { date: string; sales: number; redemptions: number }[]; // date YYYY-MM-DD
  top: { name: string; operations: number }[];
  topTotal: number;
}

const toDMY = (isoDate: string): string => {
  const [year, month, day] = isoDate.split("-");
  return `${day}/${month}/${year}`;
};

// Serie diaria lista para OperationStatistics: una fila por día del periodo.
export const toChartRows = (
  daily: DashboardSummaryProps["daily"],
  series: ("sales" | "redemptions")[]
): ChartRowProps[] =>
  daily.map((point) => {
    const row: ChartRowProps = { date: toDMY(point.date) };
    series.forEach((key) => {
      row[key] = { total: point[key] };
    });
    return row;
  });

// % de activaciones de los primeros del ranking para el donut chart, con el resto
// en un bucket "otros". El icono es la posición en el ranking (1, 2, 3...).
export const toTopItems = (
  summary: DashboardSummaryProps,
  othersLabel: string
): DonutChartDataProps[] => {
  const { top, topTotal } = summary;
  if (topTotal === 0) return [];

  const items: DonutChartDataProps[] = top.map((item, index) => ({
    name: item.name,
    value: Math.round((item.operations / topTotal) * 100),
    icon: String(index + 1),
  }));

  const restCount =
    topTotal - top.reduce((sum, item) => sum + item.operations, 0);
  if (restCount > 0) {
    items.push({
      name: othersLabel,
      value: Math.round((restCount / topTotal) * 100),
      icon: "·",
    });
  }

  return items;
};
